// Site institucional — implementado nas stories de frontend
export default function App() {
  return <div>Atualiza Imóvel</div>
}
